import React from 'react';
import { Button } from 'antd';
import { styled } from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';

const CLOSE_ICON_COLOR = 'rgba(0, 0, 0, 0.45)';
const CLOSE_ICON_HOVER_COLOR = 'rgba(0, 0, 0, 0.88)';

interface PopoverCloseButtonProps {
  onClose: () => void;
}

const CloseButton = styled(Button)`
  && {
    color: ${CLOSE_ICON_COLOR} !important;
    font-size: 16px;
  }

  &&:hover,
  &&:focus,
  &&:active {
    color: ${CLOSE_ICON_HOVER_COLOR} !important;
  }
`;

/**
 * Close button for popovers whose content behaves like a lightweight dialog.
 * Most popovers should rely on the default outside-click behavior, but popovers
 * that need an explicit close affordance should use this component for consistency.
 */
const PopoverCloseButton: React.FC<PopoverCloseButtonProps> = ({ onClose }) => {
  return (
    <CloseButton
      type="text"
      icon={<CloseOutlined />}
      onClick={onClose}
      aria-label="Close popover"
    />
  );
};

export default PopoverCloseButton;
